<template>
  <div class="breadcrumbs">
    <div
      v-for="(item, idx) in breadcrumbs"
      :key="item.id"
      class="breadcrumbs-item"
    >
      <!-- 结构化数据用 -->
      <!-- <a :href="item.path" class="item-a">{{ item.name }}</a> -->
      <div
        v-if="idx < breadcrumbs.length - 1"
        class="b-name name"
        :title="item.name"
        @click="handleBreadcrumbsClick(item)"
      >
        {{ item.name }}
      </div>
      <div
        v-else
        class="last-b-name name"
        :title="item.name"
      >
        {{ item.name }}
      </div>
      <van-icon v-if="idx < breadcrumbs.length - 1" name="arrow" size="14px" />
    </div>
  </div>
</template>

<script setup lang="ts">
export interface IBreadcrumbs {
  name: string,
  id: any,
  path?: string
}

const props = defineProps<{
  breadcrumbs: IBreadcrumbs[]
  'breadcrumbs:click'?: (item: IBreadcrumbs) => void
}>()

const handleBreadcrumbsClick = (item: IBreadcrumbs) => {
  props['breadcrumbs:click']
    ? props['breadcrumbs:click'](item)
    : console.info(item)
}
</script>

<style lang="scss" scoped>
.item-a{
  overflow: hidden;
  width: 0px;
  height: 10px;
  display: inline-block;
}
.breadcrumbs{
  display: flex;
  align-items: center;
  .breadcrumbs-item{
    font-size: 28px;
    padding: 30px 0;
    margin-right: 20px;
    display: flex;
    align-items: center;
    .name{
      display: inline-block;
      max-width: 300px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .b-name{
      margin-right: 20px;
      cursor: pointer;
      font-weight: 600;
      transition: color .1s;
      &:hover{
        color: var(--pc-default-color);
      }
    }
  }
  .breadcrumbs-item:last-child .name{
    max-width: 600px;
  }
}
</style>